import React, {FC} from 'react';

/** Текст Политики возврата средств на русском языке (структура 1:1 соответствует content/zh.tsx, классы переиспользуют BEM TermsOfUse__*). 2026-09-17 AI-перевод, юридические формулировки ожидают проверки бизнесом */
const RuContent: FC = () => {
  return (
    <>
      <p className="v3-doc-meta">Дата вступления в силу: August 28, 2026</p>
      <p className="v3-doc-meta">Дата последнего обновления: August 28, 2026</p>
      <p>Благодарим вас за использование продуктов и услуг, предоставляемых компанией Xiangji.</p>
      <p>
        Настоящая Политика возврата средств Xiangji (далее — «Политика») применяется к услугам подписки, тарифным
        планам, квотам и другим платным услугам, которые вы приобретаете у Xiangji.
      </p>
      <p>
        Xiangji стремится предоставить пользователям ясные и прозрачные правила возврата средств. Внимательно прочитайте
        настоящую Политику и полностью ознакомьтесь с ней до приобретения соответствующих услуг, в особенности
        положений, касающихся права на возврат средств, объема возврата, исключений из возврата и отмены подписки.
      </p>
      <p>
        Если приобретаемая вами отдельная услуга Xiangji предусматривает собственные специальные правила возврата
        средств, применяются такие специальные правила.
      </p>
      <section>
        <h2>1. Сфера применения права на возврат средств</h2>
        <h3>Услуги подписки SaaS</h3>
        <p>
          В отношении отдельных услуг подписки SaaS, предоставляемых Xiangji, компания Xiangji предоставляет{' '}
          <strong>гарантию возврата средств в течение 30 дней для первой покупки</strong>.
        </p>
        <p>
          Пользователи, выполняющие условия возврата, могут подать запрос на возврат средств в Xiangji в течение 30
          календарных дней с даты первой покупки соответствующей услуги подписки.
        </p>
        <h3>Определение первой покупки</h3>
        <p>
          Если прямо не предусмотрено иное, «первая покупка» означает вашу первую покупку соответствующих услуг подписки
          SaaS с использованием одного и того же аккаунта Xiangji.
        </p>
        <p>
          <strong>
            Если один и тот же пользователь повторно регистрируется и совершает покупки с использованием разных
            аккаунтов либо иными способами обходит ограничение первой покупки, такие покупки не считаются новой первой
            покупкой.
          </strong>
        </p>
        <p>
          Xiangji вправе определять, является ли покупка первой, на основании данных аккаунта, платежной информации,
          информации об устройстве, записей о заказах и иных разумных сведений.
        </p>
        <h3>Другие платные услуги</h3>
        <p>
          За исключением услуг, явно обозначенных как подпадающих под гарантию возврата средств в течение 30 дней,
          возможность возврата для других платных услуг определяется страницей покупки, страницей заказа, специальным
          соглашением об услуге или соответствующими правилами.
        </p>
      </section>
      <section>
        <h2>2. Условия возврата</h2>
        <p>Вы можете запросить возврат средств при одновременном соблюдении всех следующих условий:</p>
        <ol>
          <li>вы являетесь пользователем, имеющим право на возврат по первой покупке;</li>
          <li>запрос на возврат подан в течение 30 календарных дней с даты первой покупки соответствующей услуги;</li>
          <li>
            заказ является подлинным и действительным, при этом отсутствуют мошенничество, недобросовестная покупка или
            иное нештатное поведение;
          </li>
          <li>вы не нарушали Условия использования Xiangji или иные соответствующие правила оказания услуг;</li>
          <li>вы отвечаете иным условиям возврата, опубликованным на странице соответствующей услуги.</li>
        </ol>
        <p>
          <strong>
            Право на возврат средств не означает, что все приобретенные услуги, квоты или иные преимущества подлежат
            безусловному возврату. Фактическая сумма возврата и объем возврата определяются настоящей Политикой и
            правилами соответствующей услуги.
          </strong>
        </p>
      </section>
      <section>
        <h2>3. Сумма возврата и уже оказанные услуги</h2>
        <h3>Услуги подписки</h3>
        <p>
          В отношении услуг подписки, на которые распространяется гарантия возврата средств в течение 30 дней, Xiangji,
          как правило, возвращает фактически уплаченную вами сумму по заказам, отвечающим условиям возврата.
        </p>
        <h3>Уже использованные квоты</h3>
        <p>
          Если ваша услуга подписки также включает квоты, квоты на генерацию с помощью ИИ, квоты на перевод изображений,
          квоты на вызовы API или другие поддающиеся учету преимущества услуги,
          <strong>
            компания Xiangji вправе произвести соответствующие удержания из суммы возврата с учетом объема услуг,
            фактически использованных вами до подачи запроса на возврат.
          </strong>
        </p>
        <p>Конкретный порядок удержаний определяется на странице соответствующей услуги или правилами покупки.</p>
        <h3>Потребленные услуги</h3>
        <p>
          В отношении услуг, которые были фактически оказаны, потреблены или предоставлены и не подлежат восстановлению,
          например:
        </p>
        <ul>
          <li>завершенные переводы изображений;</li>
          <li>уже сгенерированные изображения ИИ;</li>
          <li>уже оказанные услуги редактирования или генерации изображений;</li>
          <li>уже оказанные услуги обработки видео;</li>
          <li>завершенная генерация карточек товаров или маркетинговых материалов;</li>
          <li>уже выполненные вызовы API;</li>
          <li>иные фактически потребленные услуги;</li>
        </ul>
        <p>
          Xiangji вправе исходя из фактического использования удержать соответствующую плату при возврате либо не
          возвращать стоимость потребленной части.
        </p>
        <h3>Комиссии третьих сторон</h3>
        <p>
          <strong>
            Если соответствующие услуги связаны с комиссиями, понесенными сторонними платформами, моделями ИИ,
            платежными организациями, поставщиками облачных услуг или иными третьими сторонами, и такие комиссии
            фактически понесены и не подлежат возврату, Xiangji вправе удержать соответствующие суммы из суммы возврата.
          </strong>
        </p>
      </section>
      <section>
        <h2>4. Случаи, в которых возврат не производится</h2>
        <p>В следующих случаях Xiangji, как правило, не производит возврат средств:</p>
        <ol>
          <li>подача запроса на возврат спустя более чем 30 календарных дней после первой покупки;</li>
          <li>
            покупки, не являющиеся первыми, включая переход на более высокий тариф, продление, повторную покупку или
            иные повторные покупки;
          </li>
          <li>отдельные услуги или продукты, явно обозначенные как «не подлежащие возврату»;</li>
          <li>уже использованные или потребленные квоты либо услуги;</li>
          <li>комиссии за услуги третьих сторон, которые не могут быть возмещены Xiangji;</li>
          <li>
            ошибки при покупке по вашей собственной вине, например приобретение неверного тарифного плана, аккаунта,
            количества или услуги;
          </li>
          <li>нарушение вами Условий использования Xiangji или иных соответствующих правил;</li>
          <li>
            недобросовестная регистрация, массовая регистрация, нештатные покупки, накрутка квот, злоупотребление
            политикой возврата или аналогичное поведение;
          </li>
          <li>
            мошенничество, фиктивные транзакции, несанкционированные списания с карты или иное нештатное платежное
            поведение;
          </li>
          <li>
            иные случаи, когда возврат не допускается законами и нормативными актами либо нецелесообразен с учетом
            характера конкретной услуги.
          </li>
        </ol>
        <p>
          <strong>
            Если у Xiangji есть разумные основания полагать, что пользователь осуществлял недобросовестные возвраты,
            неоднократные возвраты или иным образом злоупотреблял политикой возврата, Xiangji вправе отклонить
            соответствующий запрос на возврат и принять соответствующие меры в соответствии с Условиями использования.
          </strong>
        </p>
      </section>
      <section>
        <h2>5. Отмена подписки и автоматическое продление</h2>
        <h3>Отмена подписки</h3>
        <p>
          Если вы не желаете продолжать пользоваться услугами подписки Xiangji, вы можете отменить подписку способом,
          указанным на странице продукта.
        </p>
        <p>
          <strong>Отмена подписки автоматически не влечет возврата средств.</strong>
        </p>
        <p>
          Если вы уже оплатили текущий период подписки, отмена, как правило, означает лишь отключение последующего
          автоматического продления, и вы можете продолжать пользоваться соответствующими услугами в пределах текущего
          оплаченного периода оказания услуг, если правилами конкретной услуги не предусмотрено иное.
        </p>
        <h3>Автоматическое продление</h3>
        <p>
          Для услуг подписки с поддержкой автоматического продления вы можете отключить автоматическое продление
          соответствующим способом на странице подписки или в настройках аккаунта.
        </p>
        <p>
          После отключения автоматического продления уже оплаченный текущий период подписки, как правило, не
          возвращается автоматически.
        </p>
        <h3>Заказы продления</h3>
        <p>
          <strong>
            Если иное не предусмотрено законами и нормативными актами или прямо не указано на странице конкретной
            услуги, заказы, возникающие в результате продления подписки, автоматического продления и перехода на более
            высокий тариф, не подпадают под гарантию возврата средств в течение 30 дней для первой покупки.
          </strong>
        </p>
      </section>
      <section>
        <h2>6. Порядок подачи запроса на возврат</h2>
        <p>
          Если вы отвечаете условиям возврата, вы можете подать запрос на возврат средств в Xiangji следующими
          способами:
        </p>
        <p>
          <strong>Электронная почта службы поддержки: </strong>
          <a href="mailto:bussiness@tosoiot.com">bussiness@tosoiot.com</a>
        </p>
        <p>
          <strong>Контактный телефон: </strong>+86 176 6407 5341
        </p>
        <p>При запросе возврата, пожалуйста, укажите по возможности следующую информацию:</p>
        <ul>
          <li>ваш аккаунт Xiangji;</li>
          <li>номер заказа;</li>
          <li>время покупки;</li>
          <li>приобретенный продукт или тарифный план подписки;</li>
          <li>причину возврата;</li>
          <li>иную необходимую информацию, относящуюся к заказу.</li>
        </ul>
        <p>
          Для проверки заказа и обеспечения безопасности аккаунта Xiangji может запросить у вас необходимую информацию
          для подтверждения заказа и личности.
        </p>
      </section>
      <section>
        <h2>7. Рассмотрение и осуществление возврата</h2>
        <h3>Сроки рассмотрения</h3>
        <p>
          Xiangji рассмотрит ваш запрос после получения полного заявления на возврат и, как правило, сообщит результат
          рассмотрения в течение <strong>3 рабочих дней</strong>.
        </p>
        <p>
          Если запрос на возврат связан со сложными заказами, нештатными транзакциями, сторонними платежными
          организациями или иными ситуациями, требующими дополнительной проверки, срок рассмотрения может быть
          соразмерно продлен.
        </p>
        <h3>Способ возврата</h3>
        <p>
          <strong>
            Как правило, возврат осуществляется тем же способом, которым была произведена оплата, — на платежный счет
            или платежный метод, фактически использованные вами при оплате заказа.
          </strong>
        </p>
        <p>
          Если возврат исходным способом невозможен по причине ограничений платежной организации, банка, состояния
          аккаунта или иных объективных причин, Xiangji согласует с вами другие разумные способы возврата.
        </p>
        <h3>Сроки зачисления</h3>
        <p>
          После согласования возврата компанией Xiangji конкретный срок зачисления зависит от времени обработки
          соответствующими платежными организациями, банками и иными финансовыми учреждениями.
        </p>
        <p>
          <strong>
            Xiangji не может гарантировать зачисление возврата в течение определенного количества рабочих дней.
          </strong>
        </p>
        <p>
          Если возврат отмечен как завершенный, но вы не получили средства в разумный срок, своевременно обратитесь в
          службу поддержки Xiangji, и мы поможем вам проверить статус возврата.
        </p>
      </section>
      <section>
        <h2>8. Корректировки услуг после возврата</h2>
        <p>
          После завершения возврата Xiangji вправе внести соответствующие корректировки в ваш аккаунт и связанные с ним
          преимущества в зависимости от типа услуги, к которой относится возврат, включая, помимо прочего:
        </p>
        <ul>
          <li>отмену или прекращение соответствующих услуг подписки;</li>
          <li>списание или обнуление неиспользованных квот, относящихся к возвращенному заказу;</li>
          <li>отмену связанных привилегий членства;</li>
          <li>аннулирование неиспользованных квот или количества услуг;</li>
          <li>ограничение дальнейшего использования возвращенных услуг.</li>
        </ul>
        <p>
          <strong>
            Если после завершения возврата преимущества услуги по соответствующему заказу продолжают использоваться,
            Xiangji вправе пересчитать соответствующую плату исходя из фактического использования или принять иные
            разумные меры.
          </strong>
        </p>
      </section>
      <section>
        <h2>9. Особые платежи и сторонние платформы</h2>
        <p>
          Если вы приобретаете услуги Xiangji через Apple, Google, PayPal, Stripe или другие сторонние платежные
          платформы, возврат может потребоваться оформить в соответствии с правилами соответствующей платежной
          платформы.
        </p>
        <p>
          <strong>
            Если у сторонней платформы есть особые положения о запросах на возврат, сроках возврата или способах
            возврата, вам может потребоваться подать запрос в соответствии с процедурой соответствующей платформы.
          </strong>
        </p>
        <p>
          В отношении комиссий за обработку платежей, курсовых разниц, сбоев платежей, задержек возврата или иных
          проблем, возникающих по причине самой сторонней платежной платформы, Xiangji окажет содействие в их
          урегулировании в разумных пределах, но не несет ответственности за убытки, находящиеся вне зоны контроля
          Xiangji.
        </p>
      </section>
      <section>
        <h2>10. Изменение Политики возврата средств</h2>
        <p>
          <strong>
            Xiangji вправе изменять настоящую Политику возврата средств с учетом изменений законов и нормативных актов,
            корректировок бизнеса, изменений способов оплаты и фактических условий деятельности.
          </strong>
        </p>
        <p>
          В случае существенного изменения Политики возврата средств Xiangji уведомит вас посредством объявлений на
          сайте, на страницах продуктов, всплывающих окон, внутренних уведомлений или иными разумными способами.
        </p>
        <p>
          <strong>
            В отношении услуг, которые вы уже приобрели и срок действия которых не истек, вопросы, связанные с правом на
            возврат, по общему правилу регулируются Политикой возврата средств, действовавшей на момент вашей покупки,
            если иное не предусмотрено законами и нормативными актами или не согласовано сторонами.
          </strong>
        </p>
        <p>
          Измененная Политика возврата средств вступает в силу с даты публикации или с указанной даты вступления в силу.
        </p>
      </section>
      <section>
        <h2>11. Свяжитесь с нами</h2>
        <p>
          Если у вас есть вопросы о Политике возврата средств, праве на возврат, суммах возврата или порядке возврата,
          вы можете связаться с нами следующими способами:
        </p>
        <ul>
          <li>
            <strong>Электронная почта службы поддержки: </strong>
            <a href="mailto:bussiness@tosoiot.com">bussiness@tosoiot.com</a>
          </li>
          <li>
            <strong>Контактный телефон: </strong>+86 176 6407 5341
          </li>
          <li>
            <strong>Официальный сайт: </strong>
            <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
              https://www.xiangjifanyi.com/
            </a>
          </li>
        </ul>
        <p>Мы обработаем ваш запрос на возврат или обращение в разумный срок после его получения.</p>
        <p>
          <strong>Особое примечание: </strong>
        </p>
        <p>
          Политика возврата средств не затрагивает иные законные права, на которые вы имеете право в соответствии с
          применимыми законами и нормативными актами. Если настоящая Политика противоречит применимым законам и
          нормативным актам, приоритет имеют императивные положения законов и нормативных актов.
        </p>
      </section>
    </>
  );
};

export default RuContent;
